// import {
//   MESSAGE_SENDER,
//   MESSAGE_TYPES,
//   BUTTON_SUB_TYPES,
//   BUTTON_TYPES,
// } from "./constants"

export const getDefaultMessagesByKey = (key = "web") => {
  const defaultMessgaes = {
    web: [],
    android: [],
  }
  return defaultMessgaes[key] || []
}
